import { Link } from "react-router-dom";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <div>
          Made by <a href="https://px7.digital">PX7 Digital</a> — thoughtful software from a small Danish studio.
        </div>
        <div style={{ display: "flex", gap: "1rem" }}>
          <Link to="/about">About</Link>
          <Link to="/submit">Submit a brand</Link>
          <a href="https://accounts.px7.digital" target="_blank" rel="noreferrer">Account</a>
        </div>
      </div>
    </footer>
  );
}
